import React from 'react';
import {
  Action,
  ActionProps,
  ModalSize,
  Portal,
  useModal,
} from '@doveit/bricks';
import { Agent, ManagerGoal } from '../../../providers/api/dtos';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { ManagerGoalSimulationView } from '../manager-goal-simulation-view/ManagerGoalSimulationView';

export interface SimulateManagerGoalActionProps extends Pick<ActionProps, 'size' | 'disabled' | 'color' | 'emphasis'> {
  agentId: NonNullable<Agent['id']>,
  label?: string,
  onSuccess?: (individualGoal: ManagerGoal) => void,
  children?: ({ disabled, simulate }: { disabled?: boolean, simulate: VoidFunction }) => React.ReactNode
}

export const SimulateManagerGoalAction: React.FC<SimulateManagerGoalActionProps> = ({
  agentId,
  onSuccess,
  disabled,
  children,
  label,
  ...rest
}) => {
  const simulateGoalModal = useModal();

  const onGoalAccepted = React.useCallback((goal: ManagerGoal) => {
    onSuccess?.(goal);
    simulateGoalModal.close();
  }, [onSuccess, simulateGoalModal]);

  return (
    <>
      {children
        ? children({ disabled, simulate: simulateGoalModal.open })
        : (
          <Action
            {...rest}
            label={label || 'Simula obiettivo'}
            onClick={() => simulateGoalModal.open()}
            aria-label={'Pulsante per simulare l\'obiettivo di fatturato manager'}
          />
        )}
      <Portal>
        <SimpleModal
          {...simulateGoalModal}
          title="Simula obiettivo di fatturato"
          size={ModalSize.XLARGE}
          aria-label={'Modale per simulare l\'obiettivo di fatturato manager'}
        >
          <ManagerGoalSimulationView
            agentId={agentId}
            onGoalAccepted={onGoalAccepted}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};
